import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';
import { INSPECTION_ENDPOINTS } from '../../api/endpoints/inspection.endpoints';
import { ADMIN_ORDERS_ENDPOINTS } from '../../api/endpoints/admin-orders.endpoints';

@Injectable({
  providedIn: 'root',
})
export class InspectionService {
  private api = inject(ApiService);

  getInspectionPurpose(): Observable<any> {
    return this.api.get<any>(INSPECTION_ENDPOINTS.V1.INSPECTION_PURPOSES).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  getInspectionStatus(): Observable<any> {
    return this.api.get<any>(INSPECTION_ENDPOINTS.V1.STATUS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  getinspectionPeriods(): Observable<any> {
    return this.api.get(INSPECTION_ENDPOINTS.V1.INSPECTION_PERIODS).pipe(
      map((data: any) => {
        return data;
      }),
      catchError(this.handleError),
    );
  }

  requestReinspection(orderIds): Observable<any> {
    return this.api.post(
      ADMIN_ORDERS_ENDPOINTS.V1.CREATE_REINSPECTION_ORDER,
      orderIds,
    );
  }

  requestNewReinspection(orderId): Observable<any> {
    return this.api.post(ADMIN_ORDERS_ENDPOINTS.V1.REINSPECTION(orderId), {});
  }

  handleError(error) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
